import { fetchApplicationTenantsApi } from 'api/applications/fetchers/fetchApplicationTenantsApi'
import { createUseQuery } from 'api/common/createUseQuery'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useApplicationTenantsApi = createUseQuery({
  queryKey: ApiQueryKeys.APPLICATIONS_TENANTS,
  fetcher: fetchApplicationTenantsApi,
  selector: res => res?.data || [],
})
